var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoUpdateSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eniUZtyLDvN1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 6,
    ry: 6,
    fill: "#005b9e",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eniUZtyLDvN3",
    d: "M46.647993,27.549281c10.570762,11.146498,35.08169,36.880955,35.08169,36.880955L46.647992,100.632891",
    transform: "matrix(.951228 0 0 0.995214 3.298238 0.215654)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "eniUZtyLDvN4",
    d: "M46.647993,27.549281c10.570762,11.146498,35.08169,36.880955,35.08169,36.880955L46.647992,100.632891",
    transform: "matrix(.951228 0 0 0.995214 2.941781 0.215654)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUpdateSvg);
export default __webpack_public_path__ + "static/media/logoUpdateSvg.7351c6ebdb95090d3b7f5e050bc7303d.svg";
export { ForwardRef as ReactComponent };